<template>
  <div id="app">
    <Header  v-if="isShowRouter" />
    <router-view :key="key" class="appView" />
    <Sidebar />
    <Footer />
  </div>
</template>

<script>
import Header from "@c/header.vue";
import Footer from "@c/footer.vue";
import Sidebar from "@c/sidebar.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Sidebar,
  },
  data(){
    return{
      isShowRouter:false
    }
  },
  created() {
    this.getinfos();
    setTimeout(() => {
      this.isShowRouter = true;
      console.log('### isShowRouter', this.isShowRouter)
    }, 2000);
  },
  methods: {
    // 把数据存到store里面
    async getinfos() {
      let promistlist = []
      promistlist.push(this.$store.dispatch("service/getPageconfig"))
      promistlist.push(this.$store.dispatch("lottery/getLotterylist"))
      promistlist.push(this.$store.dispatch("news/getNewsList"))
      await Promise.all(promistlist).then((res)=>{
        console.log(res,'=========================');
        if(res){
          this.isShowRouter = true;
        }
      })
    },
  },
  computed: {
    key() {
      if (
        this.$route.name == "lotterycredit" ||
        this.$route.name == "lotterypurchase"
      ) {
        return this.$route.name + Date.now();
      }
      return this.$route.name;
    }
  }
};
</script>

<style lang="less">
body,h1,h2,h3,h4,h5,h6,p,ul,ol,dl,dd,input,button,textarea {padding: 0;margin: 0;font-size: 14px !important;}
li,ol,ul {list-style: none;}
a {text-decoration: none;}

</style>